"use client";

import { cn } from "@devhop/ui";
import type { ReactNode } from "react";

/**
 * ໂໝດງ່າຍ — browse | cart | scan (desktop)
 * Mobile: scan → cart → browse (ສະແກນກ່ອນ)
 */
export function ShopPosDesktopSimpleLayout({
  header,
  browse,
  cart,
  aside,
}: {
  header: ReactNode;
  browse: ReactNode;
  cart: ReactNode;
  aside: ReactNode;
}) {
  return (
    <div className="flex flex-col gap-4">
      {header}
      <div className="grid grid-cols-1 items-start gap-4 lg:grid-cols-[minmax(260px,300px)_minmax(0,1fr)_minmax(280px,360px)] lg:gap-5">
        <div className="order-3 min-w-0 lg:order-1 lg:max-h-[calc(100dvh-11rem)] lg:overflow-y-auto">
          {browse}
        </div>
        <div className="order-2 min-w-0 lg:order-2">{cart}</div>
        <div className="order-1 min-w-0 lg:sticky lg:top-4 lg:order-3">
          {aside}
        </div>
      </div>
    </div>
  );
}
